
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepIndicator from './components/StepIndicator';
import UserInfoStep from './components/UserInfoStep';
import InvoiceUploadStep from './components/InvoiceUploadStep';
import ReportGenerationStep from './components/ReportGenerationStep';
import type { ExpenseData } from './types';

export default function ExpensePage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [expenseData, setExpenseData] = useState<ExpenseData>({
    userName: '',
    expenseType: '',
    projectName: '',
    projectCode: '',
    invoices: [],
    totalAmount: 0,
    currencyCode: 'CNY',
    currencySymbol: '¥',
  });

  const steps = [
    { id: 1, title: '基础信息', description: '填写报销人信息' },
    { id: 2, title: '上传发票', description: '上传发票并识别' },
    { id: 3, title: '生成报销单', description: '导出报销单据' }
  ];

  const nextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const updateExpenseData = (data: Partial<ExpenseData>) => {
    setExpenseData(prev => ({ ...prev, ...data }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-100">
      <div className="container mx-auto px-4 py-8">
        {/* Header with Home Button */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            返回首页
          </button>
          <div className="text-center flex-1">
            <h1 className="text-4xl font-bold mb-2" style={{ color: 'rgb(17, 50, 99)' }}>报销系统</h1>
            <p className="text-gray-600">智能发票识别，快速生成报销单</p>
          </div>
          <div className="w-20"></div> {/* Spacer for balance */}
        </div>

        {/* Step Indicator */}
        <StepIndicator steps={steps} currentStep={currentStep} />

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            {currentStep === 1 && (
              <UserInfoStep
                data={expenseData}
                onUpdate={updateExpenseData}
                onNext={nextStep}
              />
            )}
            {currentStep === 2 && (
              <InvoiceUploadStep
                data={expenseData}
                onUpdate={updateExpenseData}
                onNext={nextStep}
                onPrev={prevStep}
              />
            )}
            {currentStep === 3 && (
              <ReportGenerationStep
                data={expenseData}
                onPrev={prevStep}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
